import React, { useState } from 'react';

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqs = [
    {
      q: "What is ValueARC and who is it for?",
      a: "ValueARC is a complete M&A operating system for IT services founders generating between ₹2 crore and ₹50 crore in revenue who are considering an exit in the next one to five years. Five integrated modules cover every stage from knowledge and preparation to buyer outreach and closing — subscribe to any module individually."
    },
    {
      q: "What launches on 16 April 2025 — and what on 18 June 2026?",
      a: "Module 1 — the M&A Masterclass — goes live on 16 April 2025. Module 2 (Value Maximizer Dashboard) and Module 3 (Intelligent VDR) launch on 18 June 2026. Launch dates for Module 4 (Go to Market) and Module 5 (Buyer Management & Outreach) will be announced separately. Founders who enroll in the Masterclass now build their foundation well ahead of the platform opening."
    },
    {
      q: "Can I subscribe to just one module?",
      a: "Yes. Every module is self-contained and valuable on its own. Start with the Masterclass, add the Dashboard, and build toward the full platform as your journey progresses. No all-or-nothing commitment required."
    },
    {
      q: "What is the 20–40% valuation uplift?",
      a: "Systematically addressing the ten dimensions of your business that buyers score can add 20 to 40 percent to your final valuation. The Value Maximizer Dashboard in Module 2 tracks your actual uplift in real time as you complete each action item."
    },
    {
      q: "Do I need prior M&A experience?",
      a: "No. The Masterclass is designed for founders with zero M&A experience. Every term is introduced in plain language through real IT services examples, building from foundational understanding to advanced execution in sequence."
    },
    {
      q: "Can I contact Sunil directly?",
      a: "Yes. Sunil answers enquiries personally at sunilnikhar@digilantsolution.com. He responds to every message."
    }
  ];

  return (
    <section className="faq-section">
      <div className="faq-inner">
        <p className="section-eyebrow">Questions</p>
        <h2 className="section-title" style={{ marginBottom: '40px' }}>Frequently asked</h2>
        {faqs.map((faq, index) => (
          <div key={index} className={`faq-item ${openIndex === index ? 'open' : ''}`}>
            <div className="faq-q" onClick={() => toggleFaq(index)}>{faq.q}</div>
            <div className="faq-a">{faq.a}</div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FAQSection;
